export const Blob = ({ color, className = "", size = 400 }) => (
  <svg
    viewBox="0 0 200 200"
    width={size}
    height={size}
    className={`blob ${className}`}
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M42.7,-62.9C55.9,-54.9,67.6,-43.9,73.4,-30.3C79.2,-16.7,79.1,-0.5,74.6,13.8C70.1,28.1,61.2,40.5,49.7,49.9C38.2,59.3,24.1,65.7,8.6,69.5C-6.9,73.3,-23.8,74.5,-37.8,68.4C-51.8,62.3,-62.9,48.9,-69.4,33.7C-75.9,18.5,-77.8,1.5,-73.9,-13.7C-70,-28.9,-60.3,-42.3,-47.8,-50.6C-35.3,-58.9,-20,-62.1,-4.4,-56.3C11.2,-50.5,22.4,-35.7,42.7,-62.9Z"
      transform="translate(100 100)"
    />
  </svg>
);
